import { Box, List, ListItem, makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { member as v_member, basic, product as v_product, Values } from '../../../request/values';
import { COLORS } from '../../../shared/Theme';
import ProductItem from './ProductItem';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		productList: {
			paddingTop: '12px',
			width: '100vw',
			height: '86vh',
			overflowY: 'auto',
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			...theme.typography.h3,
			color: `${COLORS.BROWNISH_GREY}`,
			[theme.breakpoints.up('md')]: {
				padding: '50px 5vw',
				height: '100%',
			},
			[theme.breakpoints.up('lg')]: {
				padding: '50px 10vw',
				height: '100%',
			},
		},
		card: {
			padding: 0,
			width: '100%',
			// width: '94vw',
			height: 'auto',
			border: 'solid 1px #d3d3d3',
			boxShadow: 'none',
			paddingTop: '1.2vh',
			paddingBottom: '1.2vh',
		},
		cardHeader: {
			paddingTop: 0,
			'& span > p': {
				...theme.typography.body1,
				color: `${COLORS.BROWNISH_GREY}`,
				fontFamily: 'NanumR',
				fontWeight: 'bold',
			},
			'& #cardHelpIcon span img': {
				width: '10vw',
				height: '10vw',
			},
			'& #cardHelpIcon': {
				padding: 0,
			},
			paddingBottom: 0,
			alignItems: 'flex-start',
		},
		media: {
			height: '25.5vh',
			width: '100%',
			// width: '85vw',
			margin: 'auto',
			backgroundSize: 'contain',
		},
		cardAction: {
			padding: '4vw',
		},
		cardText: {
			...theme.typography.subtitle2,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},
		icon: {
			width: '4.5vw',
			height: '4.5vw',
		},

		button: {
			width: '38vw',
			height: '4vh',
			backgroundColor: `${COLORS.PUMPKIN}`,
			color: `${COLORS.WHITE}`,
			padding: 0,
			...theme.typography.h2,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
		},

		empty: {
			textAlign: 'center',
			marginTop: '30%',
			[theme.breakpoints.up('md')]: {
				marginTop: '10%',
			},
		},

		empty_image: {
			width: '45vw',
			[theme.breakpoints.up('md')]: {
				width: '25vw',
			},
		},
	}),
);

const ProductionList: React.FC<any> = (props) => {
	const [product, setProduct] = useState<any>([]);
	const { t } = useTranslation('student');

	const { member } = props;

	const classes = useStyles();
	const history = useHistory();

	const getProductionList = () => {
		let url = new URL(basic.server + v_member.member + v_product.production_list);
		let params = { classVersion: member.classVersion, companyNum: member.companyNum.toString() };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code == Values.SUCCESS_CODE) {
					//setProduct((prevState: any) => data.products.reverse());
					setProduct((prevState: any) => data.products);
				}
			});
	};

	const goLicenseManual = (licenseNum: number) => {
		history.push(`/license/material/${licenseNum}`);
	};

	useEffect(() => {
		getProductionList();
	}, []);

	return (
		<div className="contentList" data-testid="manu-production-list-dashboard">
			<Box display="flex" justifyContent="center" alignItems="center">
				<List className={classes.productList}>
					{product.length != 0 ? (
						product.map((item: any, index: number) => {
							return (
								<ListItem
									key={index}
									style={{
										padding: 0,
										paddingBottom: 0,
										marginBottom: '1.7vh',
									}}
								>
									<ProductItem
										key={item.licenseNum}
										{...item}
										member={member}
										history={history}
										handleHelpClick={(e: any) => goLicenseManual(item.productLicenseLevel)}
									></ProductItem>
								</ListItem>
							);
						})
					) : (
						<div className={classes.empty}>
							<img className={classes.empty_image} src={'/images/no_production.webp'} />
							<Typography
								variant="h1"
								style={{
									color: `${COLORS.DOWN}`,
									marginTop: '1.5vh',
								}}
							>
								{t('ProductionList.empty')}
							</Typography>
						</div>
					)}
				</List>
			</Box>
		</div>
	);
};

export default ProductionList;
